export default "__VITE_ASSET__UP4Jmmuo__"